import { useContext, useState } from "react";
import { useMutation } from "@apollo/client";
//Import from project
import { AuthContext } from "../../../Context/AuthContext";
import { DELETE_LESSON } from "../../../Schema/Lesson";
import { useDeleteImageServer } from "../../CropImage/DeleteImageServer";

const useDeleteLesson = ({ handleClose, setRefetch, editData }) => {
  // Change Language
  const { setAlert } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);

  const mutationDelete = useDeleteImageServer();

  const [deleteLesson] = useMutation(DELETE_LESSON, {
    onCompleted: ({ deleteLesson }) => {
      setLoading(false);
      if (deleteLesson?.isSuccess === true) {
        setAlert(true, "success", deleteLesson?.message);
        handleClose();
        setRefetch();

        if (editData?.image) {
          let splitSrc = editData?.image?.split(":")[4];
          mutationDelete.mutate({
            storage: "sr_music_academy",
            folder: "sr_music_images",
            file: splitSrc.split("/")[0],
          });
        }
      } else {
        setAlert(true, "error", deleteLesson?.message);
      }
    },
    onError: ({ message }) => {
      setLoading(false);
      setAlert(true, "error", { messageKh: message, messageEn: message });
    },
  });

  const handleDelete = () => {
    setLoading(true);
    deleteLesson({
      variables: {
        id: editData?._id,
      },
    });
  };

  return { deleteLesson, loading, setLoading, handleDelete };
};

export default useDeleteLesson;
